import styled from "styled-components";

export const ContactFormAccordianContainer = styled.div`
    @media (max-width: 575.98px) { 
        margin-bottom: 70px;
    }
  .main-card-component {
    min-width: 300;
    border: none;
    border-radius: none;
    box-shadow: none !important;
    position: relative;
    &:nth-child(2) {
      position: relative;
      .header-icon {
        position: absolute;
        &::before {
          content: "";
          border-left: 3px dashed #9a9a9a;
          position: absolute;
          top: -119%;
          left: 16px;
          z-index: 998;
          width: 5px;
          height: 35px;
        }
      }
    }
    .header-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 35px;
      height: 35px;
      color: #000;
      position: absolute;
      /* background-color: #00a4e5; */
      border-radius: 50%;
      top: 13px;
      left: 15px;
    }

    .header-name {
      background-color: white;
      padding-left: 60px;

      .collapse-icon {
        background-color: white;
        color: #000;
      }
    }

    .collpased-details {
      background-color: white;
      position: relative;
      .lineCollapse {
        &::after {
          content: "";
          border-left: 3px dashed #9a9a9a;
          position: absolute;
          top: 0;
          left: 31px;
          z-index: 999;
          width: 5px;
          height: 100%;
        }
      }
    }
  }
  .accordian-details.MuiGrid-item{
    width: 100%;
    @media (max-width: 575.98px) { 
      padding-left: 0 !important;
    }
  }
  .MuiCardContent-root {
  @media (max-width: 575.98px) { 
    overflow-x: unset ;
  }
}
`;
